var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1V1.99951C2.91223 0.785343 4.3644 0 6 0H13C16.866 0 20 3.13401 20 7V13C20 16.866 16.866 20 13 20H7C3.13401 20 0 16.866 0 13V12C0 11.4477 0.447715 11 1 11C1.55228 11 2 11.4477 2 12V13C2 15.7614 4.23858 18 7 18H13C15.7614 18 18 15.7614 18 13V7C18 4.23858 15.7614 2 13 2H6C4.69378 2 3.58254 2.83481 3.17071 4L5 4C5.55228 4 6 4.44772 6 5C6 5.55228 5.55228 6 5 6H2H1C0.447715 6 0 5.55228 0 5V1ZM8.33606 6C8.33606 5.44772 8.78378 5 9.33606 5C9.88834 5 10.3361 5.44772 10.3361 6V9.58573L11.8695 11.1191C12.26 11.5097 12.26 12.1428 11.8695 12.5334C11.479 12.9239 10.8458 12.9239 10.4553 12.5334L8.70711 10.7852C8.69405 10.7721 8.68143 10.7588 8.66925 10.7452C8.46475 10.5621 8.33606 10.2961 8.33606 10V6Z",
    fill: "#A1C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.aa0a822cefae212fcb539db25b6ebb2a.svg";
export { ForwardRef as ReactComponent };